'use client';

import React from 'react';
import purify from 'dompurify';

interface SafeHTMLComponentProps {
	htmlContent: string;
	className?: string;
	style?: React.CSSProperties;
	span?: boolean;
}

const SafeHTMLComponent = ({ htmlContent, className, style, span }: SafeHTMLComponentProps) => {
	if (!htmlContent) {
		return <div className={className} style={style} />;
	}
	if (typeof purify.sanitize === 'undefined') {
		return <div className={className} style={style} />;
	}
	const sanitizedHTML = purify.sanitize(htmlContent || <div></div>);

	return <div className={className} style={style} dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />;
};

export default SafeHTMLComponent;
